module.exports = __webpack_public_path__ + "img/icon_bi2.0b807524.png";